import { Organization, OrganizationUpdateData } from "@/types/organization";
import { fetchJson } from "@/services/api-client";

export async function createOrganization(
  name: string,
  logo?: string,
): Promise<Organization> {
  const { organization } = await fetchJson<{ organization: Organization }>(
    "/api/organization",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ name, logo }),
      cache: "no-store",
    },
    { fallbackErrorMessage: "Failed to create organization" },
  );

  return organization;
}

export async function deleteOrganization(
  organizationId: string,
): Promise<void> {
  await fetchJson<unknown>(
    "/api/organization",
    {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
      cache: "no-store",
      body: JSON.stringify({ id: organizationId }),
    },
    { fallbackErrorMessage: "Failed to delete organization" },
  );
}

export async function getOrganization(
  organizationId: string,
  forceRefresh = false,
): Promise<Organization | null> {
  const url = forceRefresh
    ? `/api/organization?orgId=${organizationId}&_=${Date.now()}`
    : `/api/organization?orgId=${organizationId}`;

  const { organization } = await fetchJson<{ organization?: Organization }>(
    url,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      cache: "no-store",
    },
    { fallbackErrorMessage: "Failed to get organization" },
  );

  return organization || null;
}

export async function updateOrganization(
  orgData: OrganizationUpdateData,
): Promise<Organization> {
  const { organization } = await fetchJson<{ organization: Organization }>(
    "/api/organization",
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(orgData),
      cache: "no-store",
    },
    { fallbackErrorMessage: "Failed to update organization" },
  );

  return organization;
}
